
export default {
  props: ["questions"], // it should be like [{title:"", answer:"", ariaExpanded:false }]
  data() {
    return {
      open: null,
    };
  },
  methods: {},
};
